/**
 * Short-lived MFA session token storage (step-1 credentials success).
 * Never use this for dashboard /admin protected APIs.
 */

const MFA_SESSION_KEY = "mfaSession";

/**
 * @param {string} token
 * @param {number} [expiresInSeconds=300]
 */
export const saveMfaSession = (token, expiresInSeconds = 300) => {
  if (!token) return;
  const expiresAt = Date.now() + Number(expiresInSeconds || 300) * 1000;
  sessionStorage.setItem(
    MFA_SESSION_KEY,
    JSON.stringify({ token, expiresAt })
  );
};

/**
 * @returns {string|null}
 */
export const getMfaSessionToken = () => {
  try {
    const raw = sessionStorage.getItem(MFA_SESSION_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed?.token || !parsed?.expiresAt) {
      clearMfaSession();
      return null;
    }
    if (Date.now() >= parsed.expiresAt) {
      clearMfaSession();
      return null;
    }
    return parsed.token;
  } catch {
    clearMfaSession();
    return null;
  }
};

export const clearMfaSession = () => {
  sessionStorage.removeItem(MFA_SESSION_KEY);
};
